(() => {
  if (customElements.get('bane-october-badge')) return;
  const start = Date.parse('2026-09-30T00:00:00+02:00');
  const end = Date.parse('2026-10-08T00:00:00+02:00');
  customElements.define('bane-october-badge', class extends HTMLElement {
    connectedCallback() { this.updateVisibility(); }
    disconnectedCallback() { clearTimeout(this.timer); }
    updateVisibility() {
      clearTimeout(this.timer);
      const now = Date.now();
      const preview = this.dataset.preview === 'true';
      this.hidden = !(now < end && (now >= start || preview));
      const next = now < start && !preview ? start : end;
      if (next > now) this.timer = setTimeout(() => this.updateVisibility(), Math.min(next - now + 25, 2147483647));
    }
  });
})();
